import z from "zod";
import { stringOperatorSchema, dateOperatorSchema } from "../operations/operation-filter";
import { createZodDto } from "nestjs-zod/dto";

export const filterResumeSchema = z.object({
  title: stringOperatorSchema.optional(),
  userId: stringOperatorSchema.optional(),
  updatedAt: dateOperatorSchema.optional(),
  createdAt: dateOperatorSchema.optional(),
});

export type FilterResumeType = z.infer<typeof filterResumeSchema>;
